<mat-toolbar>
  <span>Pilotage des promotions</span>
  <span class="spacer"></span>
  <app-officine-selector type="Promotions"></app-officine-selector>
</mat-toolbar>

<div class="content">
  <app-filters [dataSource]="dataSource" (filterChange)="setFilterData($event)"> </app-filters>

  <table mat-table [dataSource]="dataSource" matSort>
    <!-- Sélectionné Column -->
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        Sélectionné
        <div>
          <mat-checkbox
            [checked]="allSelected"
            [disabled]="dataSource.filteredData.length === 0"
            (change)="setAllSelected($event.checked)"
          >
          </mat-checkbox>
        </div>
      </th>
      <td mat-cell *matCellDef="let element" [class]="getColorClass(element)">
        <mat-checkbox
          [(ngModel)]="element.flagSelection"
          (ngModelChange)="onSelectionChange(element)"
        >
        </mat-checkbox>
      </td>
    </ng-container>

    <!-- Laboratoire Column -->
    <ng-container matColumnDef="laboratoire">
      <th mat-header-cell *matHeaderCellDef>Laboratoire</th>
      <td mat-cell *matCellDef="let element" [class]="getColorClass(element)">
        {{ element.nomLaboratoire }}
      </td>
    </ng-container>

    <!-- Libellé promo -->
    <ng-container matColumnDef="libellePromo">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Libellé promo</th>
      <td mat-cell *matCellDef="let element" class="one-liner" [class]="getColorClass(element)">
        {{ element.libellePromo }}
      </td>
    </ng-container>

    <!-- Offre -->
    <ng-container matColumnDef="offre">
      <th mat-header-cell *matHeaderCellDef>Offre</th>
      <td mat-cell *matCellDef="let element" [class]="getColorClass(element)">
        {{ element.offre }}
      </td>
    </ng-container>

    <!-- Période-->
    <ng-container matColumnDef="periode">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Période</th>
      <td mat-cell *matCellDef="let element" [class]="getColorClass(element)">
        {{ element.dateDebut | date : 'dd/MM/yyyy' }} - {{ element.dateFin | date : 'dd/MM/yyyy' }}
      </td>
    </ng-container>

    <!-- Mode de compensation -->
    <ng-container matColumnDef="modeCompensation">
      <th mat-header-cell *matHeaderCellDef>Mode de compensation</th>
      <td mat-cell *matCellDef="let element" [class]="getColorClass(element)">
        {{ element.modeCompensation }}
      </td>
    </ng-container>

    <!-- Condition de sell-in -->
    <ng-container matColumnDef="conditionSellIn">
      <th mat-header-cell *matHeaderCellDef>Condition de sell-in</th>
      <td mat-cell *matCellDef="let element" [class]="getColorClass(element)">
        <mat-checkbox [checked]="element.flagSellIn" disabled> </mat-checkbox>
      </td>
    </ng-container>

    <!-- Statut -->
    <ng-container matColumnDef="statut">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Statut</th>
      <td mat-cell *matCellDef="let element" [class]="getColorClass(element)">
        <app-promotion-statut-chip [promotionStatut]="element.statut"></app-promotion-statut-chip>
      </td>
    </ng-container>

    <!-- Quantité Vendue -->
    <ng-container matColumnDef="quantiteVendue">
      <th mat-header-cell *matHeaderCellDef>Quantité vendue</th>
      <td mat-cell *matCellDef="let element" [class]="getColorClass(element)">
        {{ element.quantiteVendue }}
      </td>
    </ng-container>

    <!-- Total compensation calculée -->
    <ng-container matColumnDef="totalCompensationCalculee">
      <th mat-header-cell *matHeaderCellDef>Total compensation calculée</th>
      <td mat-cell *matCellDef="let element" [class]="getColorClass(element)">
        {{ (element.montantCompensationCalculee | customNumberFormat) + ' €' }}
      </td>
    </ng-container>

    <!-- Actions -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td
        mat-cell
        *matCellDef="let element"
        class="pointer"
        [class]="getColorClass(element)"
        (click)="openDetails(element)"
      >
        <mat-icon>arrow_forward</mat-icon>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell center" colspan="11">
        Pas de promotions trouvées. Des filtres peuvent cacher certaines promotions.
      </td>
    </tr>
  </table>
</div>
